import { render } from "./formItemConfigModal.vue?vue&type=template&id=217d81fb&ts=true"
import script from "./formItemConfigModal.vue?vue&type=script&lang=ts"
export * from "./formItemConfigModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__